{
  "Mon": "Lunedi",
  "Tue": "Martedì",
  "Wed": "Mercoledì",
  "Thu": "Giovedi",
  "Fri": "Venerdì",
  "Sat": "Sabato",
  "Sun": "Domenica",
  "CORE": {
    "notificationDateFormat": "d/M/yy",
    "update": "Loading...",
    "youAreOffline": "Device offline! Connect to a network and try again later!",
    "comeBack": "{{icon}} i tuoi sci ti aspettano",
    "help": "Aiuto",
    "notification": {
      "ok": "Fatto"
    },
    "skiHire": "Noleggio Sci"
  },
  "ALPINSKIHIRE": {
    "AR": {
      "start": {
        "selectBookingParametersFact3": "Da Alpy.com lei deve scegliere la vostra moneta. Il cambio sarà senza costi aggiunti. Corsi dei cambi saranno attualizzati ogni giorno.",
        "searchHeadline": "In quale località si desidera noleggiare gli sci o snowboard?"
      },
      "showTownReserveEarlyEnoughInfo": "Si noti che, durante la stagione, la disponibilità di attrezzatura dei noleggi sci potrebbe essere ridotta. Pertanto, è consigliabile prenotare sempre in anticipo.",
      "shop_filter_distance_to_center": "<strong>Distanza</strong> dal centro città: <strong><span id='range'>{{ distance }}</span>km</strong>",
      "shopSearch": {
        "formSearchButtonLabel": "RICERCA",
        "promocode": {
          "couponCodeIsInCart": "Il codice promozionale {{ code }} è stato aggiunto al Suo carrello e sarà incluso nella pagina di pagamento.",
          "typePromo": "PROMOZIONE",
          "typeCoupon": "BUONO SCONTO"
        }
      }
    },
    "offer": {
      "title": "Perché prenotare con {{ platformname }}"
    },
    "start": {
      "advantagesHeadline": "I migliori prezzi per il noleggio sci effettuando una prenotazione online",
      "listedBrands": "Marche esposte",
      "topTowns": "Migliori località per Noleggio Sci"
    },
    "sidebar": {
      "hotlineItalic": "Ti aiutiamo noi!",
      "callNow": "Chiama ora su: ",
      "hotline": "Hotline"
    },
    "shopSearch": {
      "validation": {
        "selectAgeForEveryChild": "Si prega di notare l'età di ogni bambino (età all'inizio del noleggio)",
        "onePersonRequired": "Scegli almeno una persona",
        "enterTown": "Scegli una delle nostre tante stazioni sciistiche"
      },
      "minified": {
        "users": "{{ number_adults }} Adultes, {{ number_children }} Bambini",
        "date": "{{ start_date }} - {{ end_date }}",
        "dateFormat": "EEEEEE d/M/yy"
      },
      "datePickerDisplayFormat": "EEEEEE d/M/yy",
      "datePickerPreviousMessage": "Puoi ritirare la tua attrezzatura a noleggio nel negozio il <span>{{ date }}</span> a 15:30. Sci notturno escluso.",
      "datePickerPreviousMessageDateFormat": "d/M/yy",
      "formSearchLabel": "Località, Comprensorio sciistico, Paese, Nome negozio, ...",
      "formSearchInfo": "Un momento per favore, la stazione desiderata è cercato...",
      "formSearchResultDescription": "({{region}}, {{province}})",
      "formSearchResultShopNumber": "{{ count }} negozi",
      "formSearchResultShowAll": "Mostra tutti i {{ count }} risultati",
      "formSearchResultGroupLocations": "Località sciistica",
      "formSearchResultGroupShops": "Shops",
      "formSearchResultGroupRegions": "Regione",
      "formSearchResultGroupCountries": "Paesi",
      "formSearchButtonLabelDelivery": "Da {{price}}",
      "deliverToHotel": "Voglio che l'attrezzatura sia consegnata presso la mia struttura – GRATIS!",
      "formStartDate": "1mo giorno",
      "formEndDate": "Ultimo giorno",
      "formNumberOfPeople": "Numero di persone",
      "formAdultsLabel": "Adultes",
      "formPeopleCount": {
        "numberOfPeople": "{{ number_adults }} {{ pluralizeAdult }} {{ number_children }} {{ pluralizeChildren }}",
        "adultNone": "Adulti",
        "adultSingle": "Adulto",
        "adultMultiple": "Adulti",
        "childNone": "Bambini",
        "childSingle": "Bambino",
        "childMultiple": "Bambini"
      },
      "formAdultsLabelInfo": "Più di 18 anni all'inizio del noleggio",
      "formChildrenLabel": "Bambini",
      "formChildrenLabelInfo": "Meno di 18 anni all'inizio del noleggio",
      "formChildInputLabelInfo": "Quanti anni ha il tuo figlio? Quanto tempo sarà tuo figlio all'inizio del periodo di noleggio?",
      "formChildInputPlaceholder": "Quanti anni è il?",
      "formPromotionCode": "Codice sconto",
      "formPromotionCodeNotFound": "Questo codice promozionale non esiste.",
      "noResults": "Nessun risultato trovato"
    },
    "trustpilot": {
      "dateformat": "d/M/yyyy",
      "score": "TrustScore",
      "reviews": "recensioni",
      "reviewsOn": "recensioni su"
    },
    "navigation": {
      "skihire": "Noleggio Sci",
      "skischool": "Scuole di sci",
      "accommodation": "Alloggi",
      "aboutUs": "Chi siamo",
      "helpCenter": "Centro Assistenzan",
      "subnavBooking": "Prenotazione",
      "subnavAdditionalOffers": "Offerte Speciali",
      "subnavGroupBooking": "Prenotazioni di gruppo",
      "subnavTermsAndConditions": "Condizioni generali di contratto",
      "subnavBecomePartner": "Diventate partner",
      "subnavPrivacyPolicy": "Norme sul trattamento dei dati personali",
      "subnavHelp": "Contatto",
      "myAlpinresorts": "Il mio Alpy.com",
      "subnavLogin": "Login/accesso",
      "subnavLogout": "Logout",
      "subnavBookingsAndCancellations": "Prenotazioni e cancellazioni",
      "subnavPersonalSettings": "Impostazioni personali",
      "career": "Carriera",
      "blog": "Blog"
    },
    "geoIp": {
      "chooseACountry": "Selezionare un Paese"
    },
    "topCountries": "Principali paesi"
  },
  "ALPINSTATIC": {
    "aboutUs": {
      "title": "Il team di Alpy.com",
      "metaDescription": "Qui trovate tutte le informazioni sul team di Alpy.com, affidatevi a una delle maggiori catene europee di noleggio e scuole di sci!"
    },
    "imprint": {
      "title": "Impressum {{ productName }}",
      "metaDescription": "Colofone di {{ productName }}"
    },
    "privacy": {
      "title": "Norme sul trattamento dei dati personali | {{ productName }}",
      "metaDescription": "Trattamento dati personali di {{ productName }}"
    },
    "termsAndConditions": {
      "title": "Condizioni generali di contratto | {{ productName }}",
      "metaDescription": "Condizioni contrattuali generali di {{ productName }}"
    },
    "additionalOffers": {
      "title": "Offerte Speciali"
    }
  },
  "ROUTES": {
    "CHECKOUT": {
      "PAYMENT": "payment",
      "CHECKOUT": "checkout"
    },
    "CANCELLATION": "cancellare-la-sua-prenotazione",
    "SKIHIREENTRY": "noleggio-ski",
    "COUNTRIES": "paesi",
    "PRODUCTS": "products",
    "PRODUCT": {
      "FINISH": "finish"
    },
    "SKIHIRE": {
      "GROUPS": "groups",
      "PRODUCTS": "products",
      "SEARCH": "cerca"
    },
    "SKISCHOOLENTRY": "scuola-di-sci",
    "STATIC": {
      "SWISSPASS": "swisspass",
      "IMPRINT": "menzione-legale",
      "PRIVACYPOLICY": "norme-sul-trattamento-dei-dati-personali",
      "TERMSANDCONDITIONS": "termini-e-condizioni",
      "HELP": "aiuto",
      "ABOUTUS": "chi-siamo",
      "ADDITIONALOFFERS": "offerte-speciali",
      "HOWTO": "come-fare"
    }
  }
}